import { render, staticRenderFns } from "./AdminGeneralSettings.vue?vue&type=template&id=02490118&scoped=true"
import script from "./AdminGeneralSettings.vue?vue&type=script&lang=ts"
export * from "./AdminGeneralSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02490118",
  null
  
)

export default component.exports